import { GithubSyncDialogData } from '@mode/github/contract';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GITHUB_FEATURE_KEY, GithubState } from './github.reducer';

// Lookup the 'Github' feature state managed by NgRx
export const githubState = createFeatureSelector<GithubState>(GITHUB_FEATURE_KEY);

export const isAuthorizedToSyncToGithub = createSelector(githubState, (state) => !!state?.syncToGithubForm);

export const githubLink = createSelector(githubState, (state) => state?.githubLink);

export const lastSynchedAt = createSelector(githubState, (state) => {
  if (state?.lastSuccessfulSyncAt) {
    return new Date(state?.lastSuccessfulSyncAt);
  }

  return;
});

export const isSyncToGithubEnabled = createSelector(githubState, (state) => !!state?.lastRunAt);

export const syncType = createSelector(githubState, (state) => state.syncType);
export const syncTargetToken = createSelector(githubState, (state) => state.syncTargetToken);
export const syncTargetName = createSelector(githubState, (state) => state.syncTargetName);
export const workspace = createSelector(githubState, (state) => state.workspace);

export const defaultCommitMessage = createSelector(
  syncType,
  syncTargetName,
  syncTargetToken,
  (syncType, syncTargetName, syncTargetToken) => {
    if (!syncType || !(syncTargetName || syncTargetToken)) return '';

    return `Update ${syncType} '${syncTargetName || syncTargetToken}'`;
  }
);

export const dialogDataForContext = createSelector(
  syncType,
  syncTargetToken,
  workspace,
  defaultCommitMessage,
  (syncType, syncTargetToken, workspace, defaultCommitMessage) => {
    if (!syncType || !syncTargetToken || !workspace) return;

    const dialogData: GithubSyncDialogData = {
      syncType: syncType,
      workspace: workspace,
      token: syncTargetToken,
      defaultCommitMessage: defaultCommitMessage,
    };
    return dialogData;
  }
);

export const lastSavedAt = createSelector(githubState, (state) => {
  if (state?.lastSavedAt) {
    return new Date(state?.lastSavedAt);
  }

  return;
});

export const hasUnsyncedChanges = createSelector(lastSynchedAt, lastSavedAt, (lastSyncTime, lastSaveTime) => {
  const synched = !!lastSyncTime && lastSaveTime && lastSyncTime > lastSaveTime;
  return !synched;
});
